// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_actions.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceStartRequest
 */
export interface AccessReviewActionsServiceStartRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: bool send_kickoff_notification = 2;
     */
    sendKickoffNotification: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceStartResponse
 */
export interface AccessReviewActionsServiceStartResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCloseRequest
 */
export interface AccessReviewActionsServiceCloseRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.CloseDecision close_decision = 2;
     */
    closeDecision: CloseDecision;
    /**
     * @generated from protobuf field: bool send_close_notification = 3;
     */
    sendCloseNotification: boolean;
    /**
     * @generated from protobuf field: bool auto_generate_report = 4;
     */
    autoGenerateReport: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCloseResponse
 */
export interface AccessReviewActionsServiceCloseResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignRequest
 */
export interface AccessReviewActionsServicePrepareCampaignRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignResponse
 */
export interface AccessReviewActionsServicePrepareCampaignResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceRevokeRequest
 */
export interface AccessReviewActionsServiceRevokeRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: repeated string selection_ids = 2;
     */
    selectionIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceRevokeResponse
 */
export interface AccessReviewActionsServiceRevokeResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportRequest
 */
export interface AccessReviewActionsServiceGenerateReportRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportResponse
 */
export interface AccessReviewActionsServiceGenerateReportResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderRequest
 */
export interface AccessReviewActionsServiceCampaignReminderRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string message = 2;
     */
    message: string;
    /**
     * @generated from protobuf field: bool cc_manager = 3;
     */
    ccManager: boolean;
    /**
     * @generated from protobuf field: repeated string user_ids = 4;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderResponse
 */
export interface AccessReviewActionsServiceCampaignReminderResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignRequest
 */
export interface AccessReviewActionsServiceDeleteCampaignRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignResponse
 */
export interface AccessReviewActionsServiceDeleteCampaignResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesRequest
 */
export interface AccessReviewActionsServiceResetCampaignPoliciesRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesResponse
 */
export interface AccessReviewActionsServiceResetCampaignPoliciesResponse {
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.CloseDecision
 */
export enum CloseDecision {
    /**
     * @generated from protobuf enum value: CLOSE_DECISION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CLOSE_DECISION_REVOKED = 1;
     */
    REVOKED = 1,
    /**
     * @generated from protobuf enum value: CLOSE_DECISION_SKIP = 2;
     */
    SKIP = 2,
    /**
     * @generated from protobuf enum value: CLOSE_DECISION_NO_ACTION = 3;
     */
    NO_ACTION = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceStartRequest$Type extends MessageType<AccessReviewActionsServiceStartRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceStartRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "send_kickoff_notification", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceStartRequest
 */
export const AccessReviewActionsServiceStartRequest = new AccessReviewActionsServiceStartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceStartResponse$Type extends MessageType<AccessReviewActionsServiceStartResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceStartResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceStartResponse
 */
export const AccessReviewActionsServiceStartResponse = new AccessReviewActionsServiceStartResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceCloseRequest$Type extends MessageType<AccessReviewActionsServiceCloseRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceCloseRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "close_decision", kind: "enum", T: () => ["c1.api.accessreview.v1.CloseDecision", CloseDecision, "CLOSE_DECISION_"] },
            { no: 3, name: "send_close_notification", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "auto_generate_report", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCloseRequest
 */
export const AccessReviewActionsServiceCloseRequest = new AccessReviewActionsServiceCloseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceCloseResponse$Type extends MessageType<AccessReviewActionsServiceCloseResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceCloseResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCloseResponse
 */
export const AccessReviewActionsServiceCloseResponse = new AccessReviewActionsServiceCloseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServicePrepareCampaignRequest$Type extends MessageType<AccessReviewActionsServicePrepareCampaignRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignRequest
 */
export const AccessReviewActionsServicePrepareCampaignRequest = new AccessReviewActionsServicePrepareCampaignRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServicePrepareCampaignResponse$Type extends MessageType<AccessReviewActionsServicePrepareCampaignResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignResponse
 */
export const AccessReviewActionsServicePrepareCampaignResponse = new AccessReviewActionsServicePrepareCampaignResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceRevokeRequest$Type extends MessageType<AccessReviewActionsServiceRevokeRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceRevokeRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "selection_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceRevokeRequest
 */
export const AccessReviewActionsServiceRevokeRequest = new AccessReviewActionsServiceRevokeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceRevokeResponse$Type extends MessageType<AccessReviewActionsServiceRevokeResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceRevokeResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceRevokeResponse
 */
export const AccessReviewActionsServiceRevokeResponse = new AccessReviewActionsServiceRevokeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceGenerateReportRequest$Type extends MessageType<AccessReviewActionsServiceGenerateReportRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportRequest
 */
export const AccessReviewActionsServiceGenerateReportRequest = new AccessReviewActionsServiceGenerateReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceGenerateReportResponse$Type extends MessageType<AccessReviewActionsServiceGenerateReportResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportResponse
 */
export const AccessReviewActionsServiceGenerateReportResponse = new AccessReviewActionsServiceGenerateReportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceCampaignReminderRequest$Type extends MessageType<AccessReviewActionsServiceCampaignReminderRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "cc_manager", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { maxItems: "500", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderRequest
 */
export const AccessReviewActionsServiceCampaignReminderRequest = new AccessReviewActionsServiceCampaignReminderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceCampaignReminderResponse$Type extends MessageType<AccessReviewActionsServiceCampaignReminderResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderResponse
 */
export const AccessReviewActionsServiceCampaignReminderResponse = new AccessReviewActionsServiceCampaignReminderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceDeleteCampaignRequest$Type extends MessageType<AccessReviewActionsServiceDeleteCampaignRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignRequest
 */
export const AccessReviewActionsServiceDeleteCampaignRequest = new AccessReviewActionsServiceDeleteCampaignRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceDeleteCampaignResponse$Type extends MessageType<AccessReviewActionsServiceDeleteCampaignResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignResponse
 */
export const AccessReviewActionsServiceDeleteCampaignResponse = new AccessReviewActionsServiceDeleteCampaignResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceResetCampaignPoliciesRequest$Type extends MessageType<AccessReviewActionsServiceResetCampaignPoliciesRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesRequest
 */
export const AccessReviewActionsServiceResetCampaignPoliciesRequest = new AccessReviewActionsServiceResetCampaignPoliciesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceResetCampaignPoliciesResponse$Type extends MessageType<AccessReviewActionsServiceResetCampaignPoliciesResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesResponse
 */
export const AccessReviewActionsServiceResetCampaignPoliciesResponse = new AccessReviewActionsServiceResetCampaignPoliciesResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewActionsService
 */
export const AccessReviewActionsService = new ServiceType("c1.api.accessreview.v1.AccessReviewActionsService", [
    { name: "Start", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceStartRequest, O: AccessReviewActionsServiceStartResponse },
    { name: "Close", localName: "close$", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceCloseRequest, O: AccessReviewActionsServiceCloseResponse },
    { name: "PrepareCampaign", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServicePrepareCampaignRequest, O: AccessReviewActionsServicePrepareCampaignResponse },
    { name: "Revoke", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceRevokeRequest, O: AccessReviewActionsServiceRevokeResponse },
    { name: "GenerateReport", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceGenerateReportRequest, O: AccessReviewActionsServiceGenerateReportResponse },
    { name: "CampaignReminder", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceCampaignReminderRequest, O: AccessReviewActionsServiceCampaignReminderResponse },
    { name: "DeleteCampaign", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceDeleteCampaignRequest, O: AccessReviewActionsServiceDeleteCampaignResponse },
    { name: "ResetDraftCampaignPolicies", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceResetCampaignPoliciesRequest, O: AccessReviewActionsServiceResetCampaignPoliciesResponse }
]);
